import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetExercisesResponse } from "../schemas/exercises";
import type { Equipment, Movement, Position } from "../schemas/shared";

export const queryKeyPrefix = "getExercises";
type QueryKey = [typeof queryKeyPrefix, GetExercisesParams];
export const getExercisesQueryKey = (params: GetExercisesParams): QueryKey => [queryKeyPrefix, params];

export interface GetExercisesParams {
  joint?: string;
  limit?: number;
  locale?: string;
  equipment?: Equipment[];
  movement?: Movement[];
  page?: number;
  position?: Position[];
  search?: string;
}

export const useGetExercises = (
  params: GetExercisesParams = {},
  options?: UseQueryOptions<GetExercisesResponse, Error, GetExercisesResponse, QueryKey>
): UseQueryResult<GetExercisesResponse, Error> => {
  const client = useApiClient();

  return useQuery(
    getExercisesQueryKey(params),
    () => {
      return client.getExercises(params);
    },
    options
  );
};
